import React from 'react';
import {connect} from 'react-redux';
import {changeDeviceSettings} from '../../../common/device/actions';

class BillPrintOff extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        billPrint: React.PropTypes.bool,
        changeDeviceSettings: React.PropTypes.func
    };

    render() {
        const {billPrint, changeDeviceSettings, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-black text-left">
                    <div className="boxBtn-inner">
                      <div className="settings-name">
                        <span className="settings-name-name">{msg.settings.printBill.title}</span>
                        <span className="settings-name-info">{msg.settings.printBill.subtitle}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                <div className="switch">
                    <div className={`switch-option text-l ${billPrint ? 'active' : ''} color-greenLight`}
                         onClick={() => changeDeviceSettings('billPrint', true)}>
                        <div className="switch-inner">
                            <span>{msg.global.yes}</span>
                        </div>
                    </div>
                    <div className={`switch-option text-l ${billPrint ? '' : 'active'} color-red`}
                         onClick={() => changeDeviceSettings('billPrint' ,false)}>
                        <div className="switch-inner">
                            <span>{msg.global.no}</span>
                        </div>
                    </div>
                </div>
              </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    billPrint: state.device.billPrint
}), {changeDeviceSettings})(BillPrintOff);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/BillPrintOff.js